import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-market-study',
  templateUrl: './market-study.component.html',
  styleUrls: ['./market-study.component.css']
})
export class MarketStudyComponent implements OnInit {

  output: any = [];
  isLoader = false;
  body = true
  space = " "
  industry_type =
    [
      { "name": "Wood" },
      { "name": "Automotive" },
      { "name": "Industrial" },
      { "name": "Building Materials" }
    ]
  search_filter = {
    created_by_id: "",
    customer_name: "",
    customer_type: "",
    industry_type: "",
    marketing_country_id: "",
    marketing_state_id: "",
    marketing_area_id: "",
  }
  country_drop: any
  statedrop: any
  areadrop: any
  constructor(private service: ServiceService, private route: ActivatedRoute, private router: Router) { }

  //excel Export For CustomerKyc
  excelExport() {
    var orderTable = document.getElementById('MarketStudy');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });

    return XLSX.writeFile(wb, ('Market Study Report.' + ('xlsx')));


  }

  ngOnInit(): void {

    this.service.viewMarketStudy().subscribe((res) => {
      this.output = res.data
      console.log("data=", this.output)
      console.log("res=", res)
    })
    this.dropdowncall()
  }

  searchListing() {
    var search_string = `?industry_type=${this.search_filter.industry_type}&marketing_country_id=${this.search_filter.marketing_country_id}&marketing_state_id=${this.search_filter.marketing_state_id}&marketing_area_id=${this.search_filter.marketing_area_id}&customer_name=${this.search_filter.customer_name}&customer_type=${this.search_filter.customer_type}`
    // debugger
    this.service.viewMarketStudy(search_string).subscribe((res) => {
      this.output = res.data
      console.log("data=", this.output)
      console.log("res=", res)

    })
  }
  industrySelected() {
    if (this.search_filter.industry_type == null) {
      this.search_filter.industry_type = ""
    }
    console.log(this.search_filter)
    this.searchListing()
  }
  countrySelected() {
    this.statedrop = []
    this.search_filter.marketing_state_id = ""
    if (this.search_filter.marketing_country_id == null) {
      this.search_filter.marketing_country_id = ""
    }
    console.log(this.search_filter)
    this.searchListing()
    this.stateDropdown()
  }
  stateSelected() {
    this.areadrop = []
    this.search_filter.marketing_area_id = ""
    if (this.search_filter.marketing_state_id == null) {
      this.search_filter.marketing_state_id = ""
    }
    this.searchListing()
    this.AreaDropdown()
  }

  areaSelected() {
    if (this.search_filter.marketing_area_id == null) {
      this.search_filter.marketing_area_id = ""
    }
    this.searchListing()
  }

  customerSelected() {
    this.searchListing()
  }

  dropdowncall() {

    this.service.viewMarketCountry().subscribe((res) => {
      this.country_drop = res.data

    })
  }
  stateDropdown() {

    var id = this.search_filter.marketing_country_id
    this.service.viewMarketState(id).subscribe((res) => {
      this.statedrop = res.data
    })
  }
  AreaDropdown() {
    var id = this.search_filter.marketing_state_id
    this.service.viewMarketArea(id).subscribe((res) => {
      this.areadrop = res.data
    })
  }




  hasProperty(property: string): boolean {
    return this.output.some((employee: any) => !!employee[property]);
}


}
